// src/components/common/SearchBar.jsx
import React, { useState, useRef, useCallback } from 'react';
import SearchBox from './SearchBox';
import fingerprintService from '../../services/fingerprintService';
import { sanitizeInput } from '../../utils/xssProtection';

export default function FingerprintSearchBox({
  value,                  // keyword
  onChange,               // setKeyword
  searchKind,               // searchKind
  onSelect,               // setSearchKind
  onSearch,               // handleSearch
  onReset,                // handleReset
  onSuggestSelect,         // 추천 클릭 시
  totalCount,               // totalCount
  onExcelDownload,         // 엑셀 다운로드
  onDelete,               // 삭제 함수
  deleteButtonConfig      // 삭제 버튼 설정
}) {
    const options = [
        { value: '0', label: '전체' },
        { value: '1', label: '회원명' },
        { value: '2', label: '아이디' },
        { value: '3', label: '이메일' },
        { value: '4', label: 'Manufacturer' },
        { value: '5', label: 'Model' },
        { value: '6', label: 'Serial' },
    ];
    
    const [suggestions, setSuggestions] = useState([]);
    const debounceTimer = useRef(null);

    /*const getTextType = (item) => {
        //전체 or 이름으로 검색시
        if(searchKind === '0' || searchKind === '1'){return item.name;}
        //id로 검색시
        if(searchKind === '2'){return item.id;}
        //email로 검색시
        if(searchKind === '3'){return item.email;}
        //manufacturer로 검색시
        if(searchKind === '4'){return item.manufacturer_name;}
        //model로 검색시
        if(searchKind === '5'){return item.model_number;}
        //serial로 검색시
        if(searchKind === '6'){return item.serial_number;}
    }*/
    
    const fetchSuggestions = useCallback(async (kw) => {
        if (!kw) return setSuggestions([]);
        
        // 검색어 길이 제한 및 위험한 문자 차단
        if (kw.length > 50 || /[<>'"&]/.test(kw)) {
            setSuggestions([]);
            return;
        }
        
        try {
            const result = await fingerprintService.getSearchSuggest(Number(searchKind), kw, 10);
            
            if (result.success && result.data) {
                // 새로운 API 응답 구조에 맞게 suggestions 매핑
                //const suggestionTexts = result.data.map(item => getTextType(item));
                const suggestionTexts = result.data.map(item => item.value);
                setSuggestions(suggestionTexts);
            } else {
                setSuggestions([]);
            }
        } catch (error) {
            console.error('fetchSuggestions error:', error);
            setSuggestions([]);
        }
    }, [searchKind]);

    // 디바운싱된 검색 제안 함수
    const debouncedFetchSuggestions = useCallback((kw) => {
        // 기존 타이머 클리어
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }
        
        // 새 타이머 설정 (300ms 지연)
        debounceTimer.current = setTimeout(() => {
            fetchSuggestions(kw);
        }, 300);
    }, [fetchSuggestions]);

    return (
      <div className="search_area">
        <div className="total_info add">등록된 지문 총 개수 <i style={{ color: '#26aea2', marginLeft: '5px' }}>{totalCount}</i>명</div>
        <SearchBox
          value={value}
          onChange={(newValue) => {
            const sanitizedValue = sanitizeInput(newValue);
            onChange(sanitizedValue); // Update keyword with sanitized value
            debouncedFetchSuggestions(sanitizedValue); // Debounced suggestions fetch
          }}
          options={options}
          selected={searchKind}
          onSelect={(newKind) => {
            onSelect(newKind); // Update search kind state
            fetchSuggestions(value); // Refresh suggestions for current keyword
          }}
          onSearch={() => {
            onSearch(); // Perform actual search (handleSearch in AccountListPage)
            setSuggestions([]); // Clear suggestions after search is committed
          }}
          onReset={onReset}
          suggestions={suggestions}
          onSuggestSelect={(selectedValue) => {
            const sanitizedValue = sanitizeInput(selectedValue);
            onSuggestSelect(sanitizedValue); // Perform search with sanitized value
            setSuggestions([]); // Clear suggestions after selection
          }}
          onExcelDownload={onExcelDownload?onExcelDownload:null}
          onDelete={onDelete}
          deleteButtonConfig={deleteButtonConfig}
        />
      </div>
    );
}